import { Create, Form, Input, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import "react-mde/lib/styles/css/react-mde-all.css";
import { ITrackKey } from "types/trackkey.interface";

export const TrackKeyCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, formLoading } = useForm<ITrackKey>();

  return (
    <Create saveButtonProps={saveButtonProps} isLoading={formLoading}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="MusicKey"
          name="musicKey"
          rules={[
            {
              required: true,
              message: "Music Key is required",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="CamelotKey"
          name="camelotKey"
          rules={[
            {
              required: true,
              message: "Camelot Key is required",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Create>
  );
};
